import { breakpoints, DropdownMenu, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDropdownMenu = styled(DropdownMenu)`
  ${DropdownMenu.Styled.DropdownContent} {
    gap: 0;
  }

  @media ${breakpoints['max-xs']} {
    width: 250px;
    min-width: 250px;
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  ${typographyV2.bodySm};
`;

export const Divider = styled.hr`
  margin: 0;
  width: 100%;
  border: 0.5px solid var(--border-soft);
`;

export const ViewSources = styled.div`
  padding: 4px 16px;
  ${typographyV2.bodySm};
  cursor: pointer;
`;
